import { Injectable, Injector } from '@angular/core';
import { VersionInfoDto } from '@common-modules/navigation/models/version-info.dto';
import { SpinnerSplashService } from '@common-modules/wlm-spinner/spinner-splash.service';
import { Observable, of } from 'rxjs';

@Injectable()
export class TCSpinnerSplashService extends SpinnerSplashService {
  constructor(injector: Injector) {
    super(injector);
  }

  getAppName(): Observable<string> {
    return of('Cloud Twin');
  }

  getLogo(): Observable<string> {
    return of('ecostruxure.png');
  }

  getVersion(): Observable<VersionInfoDto> {
    const result: VersionInfoDto = {
      productsVersion: {
        '1-ui': '1.0.0',
        '2-server': '1.0.0',
        '3-database': '1.0.0',
      },
    };
    return of(result);
  }
}
